/*
* <license header>
*/

import React from 'react'
import { Button, Flex, Heading, Text, View } from '@adobe/react-spectrum'
import { useNavigate } from 'react-router-dom'
import { Logo } from '../Logo'

export const Header = () => {
  const navigate = useNavigate()
  return (
    <div className="HomeHeader">
      <View
        marginBottom="size-500"
        padding="size-600"
        UNSAFE_style={{
          background: 'linear-gradient(90deg, #8b7cb8 0%, #673ab7 100%)',
          borderRadius: '16px',
          minHeight: '12rem'
        }}
      >
        <Flex direction="column" alignItems="center" gap="size-200">
          <Flex direction="row" alignItems="center" gap="size-200" wrap justifyContent="center">
            <Logo width={80} height={80} />
            <Heading level={1} UNSAFE_style={{ margin: 0, color: 'white', fontSize: '2rem', fontWeight: 700 }}>
              AppBuilder Factory
            </Heading>
          </Flex>
          <Text UNSAFE_style={{ color: 'white', fontSize: '1rem', textAlign: 'center', lineHeight: 1.5 }}>
          Your comprehensive guide to creating and managing Adobe App Builder applications.
          <br />
          Explore apps and accelerate development with AI-powered workflows. Supported LLMs: OpenAI, Anthropic.
        </Text>
        <Button
          variant="primary"
          UNSAFE_style={{
            backgroundColor: 'var(--card-accent)',
            borderColor: 'var(--card-accent)',
            color: 'white'
          }}
          onPress={() => navigate('/app-types')}
        >
          Explore App Types
        </Button>
      </Flex>
    </View>
    </div>
  )
}
